module.exports = __webpack_public_path__ + "static/media/info.6280d4c1.svg";